"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestateContext = void 0;
const react_1 = require("react");
exports.RestateContext = (0, react_1.createContext)({
    addScope(scopeName, scopeCreator) { throw new Error('Restate is not yet initialized.'); },
    getScope(scopeName) { throw new Error('Restate is not yet initialized.'); },
    removeScope(scopeName) { throw new Error('Restate is not yet initialized.'); },
    subscribe: (listener) => () => { return; }
});
//# sourceMappingURL=store-context.js.map